import { render, staticRenderFns } from "./TradesmanForm.vue?vue&type=template&id=484a111e&scoped=true&"
import script from "./TradesmanForm.vue?vue&type=script&lang=js&"
export * from "./TradesmanForm.vue?vue&type=script&lang=js&"
import style0 from "./TradesmanForm.vue?vue&type=style&index=0&id=484a111e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a111e",
  null
  
)

export default component.exports